module.exports = __webpack_public_path__ + "img/2x.7ddee9a.jpg";